import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import type { UpcomingContainerRow } from '../interfaces/upcomingContainers.interface';

export const upcomingContainersApi = {
  async get(companyId?: number, direction?: ShippingDirection): Promise<UpcomingContainerRow[]> {
    const params: Record<string, string | number> = {};
    if (typeof companyId === 'number') params.companyId = companyId;
    if (direction) params.direction = direction;
    const response = await http.get('/dashboard/upcoming-containers', { params });
    return (response.data?.data as UpcomingContainerRow[]) ?? [];
  },
};
